import apiClient from '@/api/index'
import { PROJECT_PREFIX } from "@/constants/projects";

export const homeModule = {
    namespaced: true,

    state:() => ({
        notifications: [],
        users: null,
        reviews: null
    }),

    mutations: {
        setNotifications(state, data) {
            state.notifications = data
        },

        setUsers(state, data) {
            state.users = data
        },

        setReviews(state, data) {
            state.reviews = data
        }
    },

    actions: {
        async getShop ({ commit, rootState }) {
            rootState.isLoading = true

            try {
                const response = await apiClient.get(PROJECT_PREFIX.tcode + "/products/", {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
            } catch (err) {
                alert(err)
            }

            rootState.isLoading = false
        },

        async getReviews ({ commit }) {
            try {
                const response = await apiClient.get("/projects/tubatay/metrics-nps/", {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                commit('setReviews', response.data)
            } catch (err) {
                alert(err)
            }
        },

        async getDashboardChart({}) {
            return apiClient.get(`/dashboard/charts/tcode/main/`, {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                console.log(error);
            });
        },
    }
}